const FeatureListInfo = [
    {
        key: 1,
        feature: "Browser compatibility",
        description: "Chrome, Firefox, Edge",
        essential: "for PC and Tablet",
        // enterprise: "for PC and Tablet",
    },
    {
        key: 2,
        feature: "Data Center",
        description: "OVH (France)",
        essential: "accessible World Wide",
        // enterprise: "accessible World Wide",
    },
    {
        key: 3,
        feature: "Connexion prerequisites",
        description: "OXE R101.0-MD3 minimum release",
        essential: true,
        // enterprise: true,
    },
    {
        key: 4,
        feature: "",
        description: "OXE Cloud Connected",
        essential: "Based on Cloud Connect Operation (CCO)",
        // enterprise: "Based on Cloud Connect Operation (CCO)",
    },
    {
        key: 5,
        feature: "Security",
        description: "HTTPS and Permanent Web Socket connection with TLS 1.2 enforced",
        essential: true,
        // enterprise: true,
    },
    {
        key: 6,
        feature: "",
        description: "Access control via MyPortal authentications and OXE accounts credential",
        essential: true,
        // enterprise: true,
    },
    {
        key: 7,
        feature: "UMC Languages",
        description: "English, French, Spanish, German",
        essential: true,
        // enterprise: true,
    },
    {
        key: 8,
        feature: "Documentation",
        description: "Help On Line (HOL) English, French, Spanish, German",
        essential: true,
        // enterprise: true,
    },
    {
        key: 9,
        feature: "",
        description: "Guidance with contextual info tooltip",
        essential: true,
        // enterprise: true,
    },
    {
        key: 10,
        feature: "",
        description: "Artificial Intelligence assistance in Help online",
        essential: true,
        // enterprise: true,
    },
    {
        key: 11,
        feature: "",
        description: "Ranking of AI answers",
        essential: true,
        // enterprise: true,
    },
    {
        key: 12,
        feature: "",
        description: "What's New module",
        essential: "notification of new UMC features in new releases",
        // enterprise: true,
    },
    {
        key: 13,
        feature: "",
        description: "Easy access to UMC Release Note",
        essential: "PDF file per release describing: specificities, bug fixing, restrictions, …",
        // enterprise: true,
    },
    {
        key: 14,
        feature: "Audit Trail / Logs",
        description: "logs of UMC actions on the current OXE PBX",
        essential: true,
        // enterprise: true,
    },
    {
        key: 15,
        feature: "",
        description: "export of UMC logs",
        essential: "in csv format",
        // enterprise: true,
    },
    {
        key: 16,
        feature: "Easy User Configuration",
        description: "Users centrix view",
        essential: "User centrix, visual, …, contextual tooltip",
        // enterprise: true,
    },
    {
        key: 17,
        feature: "",
        description: "User MACD (Modify,Add,Change,Delete)",
        essential: true,
        // enterprise: true,
    },
    {
        key: 18,
        feature: "",
        description: "Profiles to ease Users creation",
        essential: "predefined & customized profiles",
        // enterprise: true,
    },
    {
        key: 19,
        feature: "",
        description: "User profiles import/export",
        essential: "Postponed to 2026",
        // enterprise: true,
    },
    {
        key: 20,
        feature: "",
        description: "Advanced mode",
        essential: "postponed to 2026 comparison view of several parameters for several devices",
        // enterprise: true,
    },
    {
        key: 21,
        feature: "",
        description: "Key programming	",
        essential: "Visual display positioning Prog keys & Hard keys",
        // enterprise: true,
    },
    {
        key: 22,
        feature: "",
        description: "Key programming on SIP phone",
        essential: "postponed to 2026 for OXE version >= R101.2",
        // enterprise: true,
    },
    {
        key: 23,
        feature: "",
        description: "Key programming on ALE Softphone",
        essential: "postponed to 2026",
        // enterprise: true,
    },
    {
        key: 24,
        feature: "",
        description: "Key configuration shared on multidevice",
        essential: "postponed to 2026",
        // enterprise: true,
    },
    {
        key: 25,
        feature: "",
        description: "Key programming Key profiles",
        essential: "postponed to 2026 to easy repetitive configuration of keys",
        // enterprise: true,
    },
    {
        key: 26,
        feature: "",
        description: "Add-on module management",
        essential: "Graphical view",
        // enterprise: true,
    },
    {
        key: 27,
        feature: "",
        description: "Multidevice management",
        essential: "automatic creation, association and configuration of multidevices for Mobility and softphony with 4 types of multidevice (Rainbow, ALE SoftPhone (PC/Mobile), IP Desktop Softphone, DECT) automatic duplication of some primary parameters on multidevices",
        // enterprise: true,
    },
    {
        key: 28,
        feature: "",
        description: "Group management Pickup group",
        essential: true
        // enterprise: true,
    },
    {
        key: 29,
        feature: "",
        description: "Group management Hunting group",
        essential: true
        // enterprise: true,
    },
    {
        key: 30,
        feature: "",
        description: "Desk Sharing set & desk Sharing user management",
        essential: "Postponed to 2026"
        // enterprise: true,
    },
    {
        key: 31,
        feature: "",
        description: "Authentication mode for ALE-Softphone External authentication",
        essential: "external authentication via LDAP from R1.0"
        // enterprise: true,
    },
    {
        key: 32,
        feature: "",
        description: "Authentication mode for ALE-Softphone Local authentication",
        essential: "Postponed to 2026"
        // enterprise: true,
    },
    {
        key: 33,
        feature: "",
        description: "Search for individual User",
        essential: "search by Directory Number, name, device type, active license, …"
        // enterprise: true,
    },
    {
        key: 34,
        feature: "Easy SIP trunk creation",
        description: "Wizard for SIP trunk creation",
        essential: "with logs of all OXE data impacted"
        // enterprise: true,
    },
    {
        key: 35,
        feature: "",
        description: "Profiles to ease public SIP trunk creation",
        essential: "Profiles for  SIP providers supported on OXE (refer to TC2005 : SIP providers supported on OmniPCX® Enterprise). 3 Profile types : SBC, VPN, Internet. 18 profiles available in R1.0, additional profiles in next sprint."
        // enterprise: true,
    },
    {
        key: 36,
        feature: "",
        description: "Profiles for private SIP trunk creation",
        essential: "Visual Automated Attendant (VAA) from R1.1 Rainbow WebRTC GW from R1.0"
        // enterprise: true,
    },
    {
        key: 37,
        feature: "",
        description: "List of all configured SIP trunks  in OXE",
        essential: true
        // enterprise: true,
    },
    {
        key: 38,
        feature: "",
        description: "Discrimination auto provisioning",
        essential: "for systems without configured Discrimination"
        // enterprise: true,
    },
    {
        key: 39,
        feature: "",
        description: "Integration with an existing Discrimination",
        essential: "enhancement planned for 2026"
        // enterprise: true,
    },
    {
        key: 40,
        feature: "Expert Configuration",
        description: "Remote Web base management",
        essential: true
        // enterprise: true,
    },
    {
        key: 41,
        feature: "Directory Synchronization",
        description: "Microsoft ENTRA directory synchronisation",
        essential: "synchronization with a Cloud Corporate Directory via SCIM protocol in TRIAL mode in R1.1 and will be chargeable from UMC2.0"
        // enterprise: true,
    },
    {
        key: 42,
        feature: "",
        description: "User Creation/automatic update",
        essential: true
        // enterprise: true,
    },
    {
        key: 43,
        feature: "",
        description: "User Deletion/Manual update",
        essential: "postponed to 2026"
        // enterprise: true,
    },
    {
        key: 44,
        feature: "Integrated Management",
        description: "Rainbow Webadmin access",
        essential: true
        // enterprise: true,
    },
    {
        key: 45,
        feature: "",
        description: "MyPortal/Service manager access",
        essential: "Redirection to Service Manager (MyPortal) For subscription management of the selected Purple on Demand system"
        // enterprise: true,
    },
    {
        key: 46,
        feature: "",
        description: "Fleet Dashboard access",
        essential: "Redirection to Fleet Dashboard portal for technical actions on the selected OXE system"
        // enterprise: true,
    },
    {
        key: 47,
        feature: "",
        description: "Alarms",
        essential: "For daily alarm assessment via Fleet Dashboard link (No real time)"
        // enterprise: true,

    },
    {
        key: 48,
        feature: "Links",
        description: "Useful shortcuts of ALE portals",
        essential: "Predefined links helpful for OXE configuration"
        // enterprise: true,
    },
    {
        key: 49,
        feature: "Artificial Intelligence (AI)",
        description: "AI assistant for Document search",
        essential: "AWS Private Library"
        // enterprise: true,
    },
    {
        key: 50,
        feature: "",
        description: "Result Rating",
        essential: "Allowing documentation improvements"
        // enterprise: true,

    },
    {
        key: 51,
        feature: "",
        description: "Search by Voice",
        essential: "Speech-to-text for document search"
        // enterprise: true,
    }
]

export default FeatureListInfo